import { connect } from 'react-redux'
import reloadApplication from '../../actions/synchronize/reloadApplication'
import getCriticalErrorModalIsOpen from '../../reducers/synchronize/selectors/getCriticalErrorModalIsOpen'
import CriticalErrorModal from './CriticalErrorModal'

const mapStateToProps = state => ({
  open: getCriticalErrorModalIsOpen(state),
})

const mapDispatchToProps = dispatch => ({
  reloadApp: () => dispatch(reloadApplication()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CriticalErrorModal)
